import type { TrackScores } from "@/lib/trackRecord";
import type { TrackRecord } from "@/lib/types";

export type TileTrack = "paid" | "volunteer" | "creator";

export interface TrackTile {
  key: TileTrack;
  score: number;
  /** The count that matters for the track: tasks done, or quests launched. */
  count: number;
  /** The tile's one-line summary, as an i18n key and its params. */
  detail: { key: string; params: Record<string, number> };
}

function round1(n: number): number {
  return Math.round(n * 10) / 10;
}

/** Three separate tracks -- paid work, volunteer impact, quest creator -- shared by the tiles and the menu strip. */
export function trackTiles({ worker, creator }: TrackRecord, scores: TrackScores): TrackTile[] {
  return [
    {
      key: "paid",
      score: scores.paid,
      count: worker.paidTasks,
      detail: { key: "trackRecord.paidDetail", params: { count: worker.paidTasks, hours: round1(worker.paidHours) } },
    },
    {
      key: "volunteer",
      score: scores.volunteer,
      count: worker.volunteerTasks,
      detail: {
        key: "trackRecord.volunteerDetail",
        params: { count: worker.volunteerTasks, hours: round1(worker.volunteerHours) },
      },
    },
    {
      key: "creator",
      score: scores.creator,
      count: creator.questsLaunched,
      detail: {
        key: "trackRecord.creatorDetail",
        params: { count: creator.questsLaunched, workers: creator.workersHired },
      },
    },
  ];
}
